import { render, staticRenderFns } from "./formTwo.vue?vue&type=template&id=2c3fb9b5&scoped=true&"
import script from "./formTwo.vue?vue&type=script&lang=js&"
export * from "./formTwo.vue?vue&type=script&lang=js&"
import style0 from "./formTwo.vue?vue&type=style&index=0&id=2c3fb9b5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3fb9b5",
  null
  
)

export default component.exports